/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { installCspNonceForDynamicElements } from './app/shared/utils/csp-nonce.util';

installCspNonceForDynamicElements();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
